<template>
  <div class="page">
    <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
      <a-row slot="title" type="flex" justify="space-between">
        <a-col :span="8">
          <span class="card-title">推荐{{ catalogId == 1 ? '门票' : '酒店' }}专题</span>
        </a-col>
        <a-col :span="8" class="text-right">
          <a-button type="primary" @click="addSpecial(0)">添 加</a-button>
        </a-col>
      </a-row>
      <a-table
        :columns="columns"
        rowKey="specialId"
        :dataSource="specialProList" :pagination="false">
        <div class="image-table" slot="imageSlots" slot-scope="text">
          <CustomImage :imageUrl="text"></CustomImage>
        </div>
        <div slot="action" slot-scope="text,record">
          <a @click="editData(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm
            title="是否要删除当前专题？"
            @confirm="deleteEvent(record)">
            <a-icon slot="icon" type="close-circle" style="color: red"/>
            <a>删除</a>
          </a-popconfirm>
        </div>
      </a-table>
    </a-card>
    <!-- 专题弹窗 -->
    <a-modal :title="catalogId==1?'门票专题':'酒店专题'"
             :visible="visibleDialog"
             @ok="handleSubmit"
             @cancel="handleCancel"
             :confirmLoading="confirmLoading"
             :width="600"
    >
      <a-form :form="form" class="form-arrow">
        <a-form-item label="专题名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input placeholder="6个字以内" :maxLength="6"
                   v-decorator="['specialName', { rules: [{ required: true, message: '请输入专题名称' }] }]"/>
        </a-form-item>
        <a-form-item label="排序" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input placeholder="默认0" :maxLength="10"
                   v-decorator="['specialSort', { rules: [{ required: true, message: '请输入排序' },{ pattern: /^[0-9]\d*$/, message: '请输入排序值', trigger: 'blur'}] }]"/>
        </a-form-item>
        <a-form-item label="关联主题" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-select style="width: 100%" @change="handleSelectChange"
                    v-decorator="['specialThemeId', { rules: [{ required: true, message: '请选择关联主题' }] }]"
                    placeholder="请选择" allowClear>
            <a-select-option v-for="item in themeList" :key="item.themeId" :value="item.themeId">{{ item.themeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="selectThemeId==0" label="专题图标" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <p style="color:red;font-size:13px;">图片尺寸为200px*200px，图片格式为.jpg .png。不传则显示默认图标</p>
          <a-upload
            name="avatar"
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            :action="uploadFileUrl"
            @change="handleChange"
            :before-upload="handleBeforeUploadImage"
            v-decorator="[ 'specialImg', {rules: [{ required: true, message: '请上传图片' }]}]"
          >
            <img class="img-upload" v-if="imageUrl" :src="imageUrl" alt="avatar"/>
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'"/>
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item v-if="selectThemeId==0" label="商品ID" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-textarea v-decorator="['proIds', { rules: [{ required: true, message: '请输入退款备注' }] }]"
                      placeholder="仅支持酒店商品ID，一行一个，最多1000个" :maxLength="300" :rows="4"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import formMixins from '@/utils/mixins/formMixins'

export default {
  name: 'specialTable',
  mixins: [formMixins],
  data() {
    return {
      visibleDialog: false,
      confirmLoading: false,
      loading: false,
      catalogId: this.$route.query.catalogId,//商品类型
      merchantId: this.$store.getters.userInfo.merchantId,
      selectThemeId: 0,
      fileList: [],
      specialProList: [],
      imageUrl: '',
      channelStatus: 0,
      queryParams: {},
      themeList: [],
      columns: [
        {
          title: '专题ID',
          dataIndex: 'specialId'
        },
        {
          title: '图标',
          dataIndex: 'specialImg',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '专题名称',
          dataIndex: 'specialName'
        },

        {
          title: '关联主题',
          dataIndex: 'themeName'
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.getThemeList()
    this.getSpecialList()
  },
  methods: {
    handleSelectChange(value) {
      this.getLogUtils().logWithTag(`selected ${value}`)
      this.selectThemeId = value
      if (this.selectThemeId == 0) {
        this.$nextTick(() => {
          this.imageUrl = ''
          this.form.setFieldsValue({
            proIds: undefined,
            specialImg: undefined
          })
        })
      }
    },
    getThemeList() {
      this.getHttpServices().getProService().get('product/proSpecial/getThemeList?proType=' + this.catalogId).then(res => {
        this.themeList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取表格数据接口
    getSpecialList() {
      this.getHttpServices().getProService().get('product/proSpecial/getSpecialList?merchantId=' + this.merchantId + '&proType=' + this.catalogId).then(res => {
        this.specialProList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    addSpecial(id) {
      this.visibleDialog = true
      this.specialId = id
      this.selectThemeId = 0
      this.imageUrl = ''
      this.form.resetFields()
      this.$nextTick(() => {
        this.form.setFieldsValue({
          specialSort: 0,
          specialThemeId: 0
        })
      })
    },
    // 编辑
    editData(data) {
      this.getLogUtils().logWithTag('==editData==', data)
      this.visibleDialog = true
      this.specialId = data.specialId
      this.getHttpServices().getProService().get('product/proSpecial/getSpecialDetails?specialId=' + data.specialId).then(res => {
        this.$nextTick(() => {
          this.selectThemeId = res.specialThemeId
          this.imageUrl = res.specialImg
          this.form.setFieldsValue({
            specialSort: res.specialSort,
            specialThemeId: res.specialThemeId,
            specialName: res.specialName
          })
          if (res.specialThemeId == 0) {
            setTimeout(() => {
              this.form.setFieldsValue({
                proIds: res.proIds,
                specialImg: [
                  {
                    uid: '-1',
                    name: res.specialImg,
                    status: 'done',
                    url: res.specialImg
                  }
                ]
              })
            }, 500)
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 删除
    deleteEvent(data) {
      this.getLogUtils().logWithTag('deleteEvent', data)
      this.getHttpServices().getProService().get('product/proSpecial/delSpecial?specialId=' + data.specialId + '&proType=' + this.catalogId)
        .then(res => {
          this.getLogUtils().logWithTag('==deleteEvent==', res)
          this.getSpecialList()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleCancel() {
      this.visibleDialog = false
    },
    // 图片上传
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        if (info.file.response.status == 1) {
          this.$message.success('图片上传成功')
          this.imageUrl = info.file.response.data
          this.loading = false
        } else {
          this.$message.error(info.file.response.msg)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`)
      }
    },
    handleSubmit() {
      this.validateFormParams().then(res => {
        this.getLogUtils().logWithTag('默认表单数据', res)
        let params = res
        params.specialImg = this.imageUrl
        params.specialId = this.specialId
        params.specialProType = this.catalogId
        this.getLogUtils().logWithTag('中表单数据params', params)
        this.confirmLoading = true
        this.getHttpServices().getProService().post('product/proSpecial/updateSpecial', params)
          .then(res => {
            this.getLogUtils().logWithTag('==handleSubmit==', res)
            this.$message.success('操作成功')
            this.visibleDialog = false
            this.getSpecialList()
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
      })
    }
  }

}
</script>
<style lang="less" scoped>
@import url('../../CustomPage.less');

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.text-right {
  text-align: right;
}

.image-table {
  width: 40px;
  height: 40px;

  img {
    width: 40px;
    height: 40px;
  }
}

.form-arrow {
  input {
    max-width: none;
  }
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.img-upload {
  width: 128px;
  height: 128px;
}
</style>